import { animate, scroll, inView } from "motion";

document.addEventListener('DOMContentLoaded', () => {
    const blockShowcaseCarousel = document.querySelector('.block-showcase-carousel');

    if (!blockShowcaseCarousel) return;

    const blockShowcaseCarouselShowcase = blockShowcaseCarousel.querySelectorAll('.block-showcase-carousel__showcase');
    const blockShowcaseCarouselButtons  = blockShowcaseCarousel.querySelectorAll('.block-showcase-carousel__button');

    // Animations
    inView(blockShowcaseCarousel, () => {
        if (blockShowcaseCarousel.querySelector('.block-showcase-carousel__content')) {
            animate(
                blockShowcaseCarousel.querySelector('.block-showcase-carousel__content'), 
                { 
                    opacity: [0, 1],
                    transform: ['translateY(60px)', 'translateY(0)'],
                }, 
                { 
                    duration: 0.6,
                    delay: 0.3
                }
            );
        }

        if (window.innerWidth >= 768 && blockShowcaseCarousel.querySelector('.block-showcase-carousel__content__heading')) {
            scroll(
                animate(
                    blockShowcaseCarousel.querySelector('.block-showcase-carousel__content__heading'),
                    { y: [0, -600] },
                    { ease: "ease-in-out" }
                )
            );
        }
    });

    const showShowcase = (index) => {
        blockShowcaseCarouselShowcase.forEach((showcase, idx) => {
            showcase.style.display = idx === index ? 'block' : 'none';

            if (idx === index) {
                inView(showcase, () => {
                    if (showcase.querySelector('img')) {
                        animate(
                            showcase.querySelector('img'), 
                            {
                                opacity: [0, 1],
                                transform: ['translateX(60px)', 'translateX(0)'],
                            },
                            { duration: 0.6 }
                        );
                    }

                    const videoContainer = showcase.querySelector('.block-showcase-carousel__showcase__video');
                    const video = videoContainer?.querySelector('video');

                    if (videoContainer && video) {
                        animate(
                            videoContainer,
                            {
                                opacity: [0, 1],
                                transform: ['translateX(60px)', 'translateX(0)'],
                            },
                            { duration: 0.6 }
                        );

                        scroll(
                            animate(
                                video,
                                { y: [100, -400] },
                                { ease: "ease-in-out" }
                            )
                        );

                        // Autoplay when in view
                        inView(videoContainer, () => {
                            if (video.paused) {
                                video.play().catch(err => {
                                    console.warn("Autoplay failed:", err);
                                });
                            }
                        }, {
                            amount: 0.5,
                            once: true
                        });
                    }

                    if (showcase.querySelector('.block-showcase-carousel__showcase__content')) {
                        animate(
                            showcase.querySelector('.block-showcase-carousel__showcase__content'),
                            {
                                opacity: [0, 1],
                                transform: ['translateY(-60px)', 'translateX(0)'],
                            },
                            { duration: 0.6 }
                        );
                    }

                    if (showcase.querySelector('.block-showcase-carousel__showcase__border')) {
                        animate(
                            showcase.querySelector('.block-showcase-carousel__showcase__border'),
                            { opacity: [0, 1] },
                            { duration: 1.2 }
                        );
                    }

                    if (showcase.querySelector('.block-showcase-carousel__showcase__background')) {
                        animate(
                            showcase.querySelector('.block-showcase-carousel__showcase__background'),
                            { opacity: [0, 1] },
                            { duration: 1.2 }
                        );
                    }

                    if (showcase.querySelector('picture')) {
                        scroll(
                            animate(
                                showcase.querySelector('picture'),
                                { y: [100, -400] },
                                { ease: "ease-in-out" }
                            )
                        );
                    }
                });
            }
        });

        blockShowcaseCarouselButtons.forEach((button, idx) => {
            button.classList.toggle('bg-[#ADC0ED]/20', idx === index);
        });
    };

    showShowcase(0);

    blockShowcaseCarouselButtons.forEach(button => {
        button.addEventListener('click', () => {
            const index = parseInt(button.getAttribute('data-index'), 10);
            showShowcase(index);
        });
    });
});